module.exports = __webpack_public_path__ + "static/media/licenta18.e67c1c8f.png";